import { HttpError } from './HttpError';

export class HttpUnauthorized  extends HttpError {
    constructor(public OriginalError?: any, public FriendlyTitle?: string, public FriendlyMessage?: string) {
        super(OriginalError);
    }
}
